import { LadzoConsole as Lc } from "../global/ladzo-console.js";
import { createApp } from "vue";
import App from "../../vue/StitkyMistMultiselect.vue";
import "vue-multiselect/dist/vue-multiselect.css";
export function zobraz() {
  Lc.f("zobrazMapu pres mapaApp");
  createApp(App).mount("#dvStitkyMista");
}
